import React from "react";
import {Form} from "react-bootstrap";

class Search extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      needSubmitOnBlur: false
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleClearMouseDown = this.handleClearMouseDown.bind(this);
  }

  handleInputChange(event) {
    const { value } = event.target;
    this.setState({ needSubmitOnBlur: true })
    this.props.onSearchChange(value);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ needSubmitOnBlur: false })
    this.props.handleSearch();
  }
  
  handleInputBlur = (event) => {
    if (this.state.needSubmitOnBlur) {
      this.handleSubmit(event)
    }
  };

  handleClearMouseDown = (event) => {
    // before focus leaves, tell React that
    // we are clearing.  The onBlur will see
    // this flag and bail out.
    this.setState({ needSubmitOnBlur: false })
  }

  async handleClear() {
    // actually clear & re-search
    this.setState({ needSubmitOnBlur: false })
    await this.props.onSearchChange('')
    this.props.handleSearch()
  }

  render() {
    return (
      <Form  className="search"
        onSubmit={this.handleSubmit}>
        <div className="search-container">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#cecbcb" className="search-icon">
            <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clipRule="evenodd" />
          </svg>
          <input 
            type="text"
            name="search"  
            value={this.props.searchString} 
            onChange={this.handleInputChange}
            onBlur={this.handleInputBlur}            
            placeholder="SBT, Ref #, Product, Depot, Ordered By"
          />
          {this.props.searchString ? 
          <button
            className="btn-clear"
            type="button"
            onMouseDown={this.handleClearMouseDown}
            onClick={() => this.handleClear()}
          >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#cecbcb" className="search-icon">
            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
          </svg>
          </button> : ''}
        </div>
      </Form>
    );
  }
}

export default Search;
